import { render, staticRenderFns } from "./Component-VideoMonitorPanel.vue?vue&type=template&id=285a594d&"
import script from "./Component-VideoMonitorPanel.vue?vue&type=script&lang=js&"
export * from "./Component-VideoMonitorPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports